






























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Utils } from "@/service/util";
import { ElInput } from "element-ui/types/input";
import { ElButton } from "element-ui/types/button";
@Component
export default class InputString extends Vue {
  @Prop() maxbyte!: number;
  @Prop() index!: number;
  @Prop() isFullWidth!: boolean;
  @Prop() inputName!: string;
  @Prop() readonly: any;
  @Prop() value!: string;
  @Prop() type!: string;
  @Prop() rows!: number;
  @Prop() placeholder!: string;
  @Prop() className!: string;
  @Prop({ default: "medium" })
  size!: string;
  currentValue: string = "";
  showDialog: boolean = false;
  msg: string = "";
  timerSelect: any = null;

  public utils: Utils = new Utils();

  $refs!: {
    input: ElInput;
    btnOk: ElButton;
  };

  @Watch("value")
  onValueChange(value: any, oldVal: any) {
    this.initValue();
  }

  created() {
    this.initValue();
  }

  initValue() {
    if (this.value != undefined) {
      this.currentValue = this.value;
    }
  }

  setAlertMsg() {
    if (this.maxbyte) {
      const zenhanlabel = this.isFullWidth ? "全角" : "半角";
      const max = this.isFullWidth ? this.maxbyte / 2 : this.maxbyte;
      this.msg = `${
        this.inputName
      }は${zenhanlabel}${max}文字以内で入力してください`;
    }
  }

  onEnter() {
    this.clearTimerSelect();
    this.utils.focusNext(this.index);
  }

  onFocus() {
    if (!this.readonly) {
      this.clearTimerSelect();
      this.timerSelect = setTimeout(() => {
        this.$refs.input.select();
      }, 200);
    }
  }

  onBlur() {
    this.clearTimerSelect();
    if (this.maxbyte) {
      const length = this.utils.getUTF8Length(this.currentValue, this.maxbyte).count;
      if (length > this.maxbyte) {
        if (this.msg == "") {
          this.setAlertMsg();
        }
        this.showDialog = true;
      } else {
        this.emitFocusout();
      }
    } else {
      this.emitFocusout();
    }
  }

  emitFocusout() {
    this.$emit("focusout", this.currentValue);
    this.$emit("input", this.currentValue);
  }

  getValue() {
    return this.currentValue;
  }

  onClose() {
    this.showDialog = false;
    this.focus();
  }

  onDialogOpened() {
    this.$refs.btnOk.$el.focus();
  }

  focus() {
    this.$refs.input.focus();
  }

  onKeyup(e: any) {
    this.$emit("input", e.target.value);
  }

  clearTimerSelect() {
    if (this.timerSelect) {
      clearTimeout(this.timerSelect);
      this.timerSelect = null;
    }
  }
}
